module.exports = __webpack_public_path__ + "img/待发货.26110992.jpg";